import { environment } from './environment';

/**
 * Résolution de l'URL de l'API au démarrage, à partir du domaine servant le front.
 *
 * Pourquoi au runtime plutôt qu'au build : Nexum produit UN seul artefact à partir d'un
 * commit, puis le déploie sur l'environnement choisi. Une URL figée au build est donc
 * forcément fausse sur au moins un environnement — c'est ce qui a mis la prod sur l'API de
 * dev, `ng build` prenant la configuration par défaut `staging` d'angular.json.
 *
 * La table ne liste que les cas qui s'écartent de la valeur du build. Tout le reste retombe
 * sur `environment.apiBaseUrl` : la dev déployée (buildée en `staging`, donc déjà correcte)
 * et le poste de dev en local (configuration `development`, donc localhost).
 *
 * Pour ajouter un environnement, ajouter une ligne ici — le nom du domaine de l'API ne se
 * déduit pas de celui du front, les deux ne suivent pas la même convention de nommage.
 */
const API_BY_FRONT_HOST: Readonly<Record<string, string | undefined>> = {
  'tpvweb-asct.tvmview.apps.kubapay.io':
    'https://api.tvmview-prod.environments.apps.kubapay.io/api/v1',
};

/** Exportée pour être testable sans toucher à window. */
export function resolveApiBaseUrl(hostname: string): string {
  return API_BY_FRONT_HOST[hostname] ?? environment.apiBaseUrl;
}

function currentHostname(): string {
  return typeof window === 'undefined' ? '' : window.location.hostname;
}

export const API_BASE_URL = resolveApiBaseUrl(currentHostname());
